import React from "react";
import PropTypes from "prop-types";
import { Subscribe } from "unstated";
import SrpContainer from "../containers/SrpContainer";

const CityList = ({ cities }) => {
  if (!cities) return null;
  return (
    <section className="no-srp-cities">
      <h3>Browse Venues by city</h3>
      <ul>
        {cities.map(({ city, url }) => (
          <li key={city}>
            <a href={url} className="ux-a">
              {city}
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
};

CityList.propTypes = {
  cities: PropTypes.arrayOf(
    PropTypes.shape({
      city: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    })
  ),
};

const CityListContainer = () => (
  <Subscribe to={[SrpContainer]}>
    {({ state: { data } }) => <CityList cities={data.cities} />}
  </Subscribe>
);

export default CityListContainer;
